import MobileDetect from 'mobile-detect';

import HandshqApp from '../handshq-app';

HandshqApp.mobileDetect = new MobileDetect(window.navigator.userAgent);
